<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('users.account_title')"/>
        <div class="col-sm-12 editor-form mt-2 p-3" style="border-radius: .5em">
          <span style="font-size: 2.4em; font-weight: 300; color: #70a901; display: block">{{ user.first_name }} {{ user.last_name }}</span>
          <span style="font-size: 1.2em; color: #404041; display: block; padding-left: .25em"> {{ user.email }} </span>
          <span style="font-size: 1.2em; color: #404041; display: block; padding-left: .25em"> {{ user.company.name }} </span>
            <div class="col-12 d-flex justify-content-end">
                <button v-if="!userCompanies || userCompanies.length < 1" class="btn btn-outline-primary form-button my-3" @click.stop="$emit('changeOrganization')">
                    {{ $t('menu.change_company') }}
                </button>
            </div>
            <hr/>
            <change-password class="my-2" />
        </div>
    </div>
</template>

<script>
import ChangePassword from './ChangePassword'
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'MyAccount',
    components: {Navbar, ChangePassword},
    props: {
        user: {
            type: Object,
            default: null
        },
        userCompanies: {
            type: Array,
            default: []
        }
    }
}
</script>
